jQuery.feature_import("js-charts-bar",
  () => require("./charts-bar.js"),
  mod => mod.feature_js_charts_bar
);